import React from 'react';
import { Loader2, User, Trash2 } from 'lucide-react';
import { Badge } from '../../../../components/ui/Badge';
import { formatDate } from '../utils/formatters';

export const AssignedRolesList = ({
  selectedEmployee,
  assignmentsLoading,
  assignmentsError,
  employeeAssignments,
  onUnassignRole,
  onSyncToAuthentik
}) => {
  if (!selectedEmployee) return null;

  const fullName = selectedEmployee.first_name && selectedEmployee.last_name
    ? `${selectedEmployee.first_name} ${selectedEmployee.last_name}`
    : selectedEmployee.first_name || selectedEmployee.last_name || 'N/A';

  // Aplanar factories → departments → roles para una tarjeta por rol
  const roleCards = [];
  if (employeeAssignments?.factories) {
    employeeAssignments.factories.forEach((factory) => {
      (factory.departments || []).forEach((dept) => {
        (dept.roles || []).forEach((role) => {
          roleCards.push({
            key: `${factory.factory_id}-${dept.department_id}-${role.id}`,
            factoryId: factory.factory_id,
            departmentId: dept.department_id,
            factoryName: factory.factory_name || `Fábrica ${factory.factory_id}`,
            departmentName: dept.department_name || `Departamento ${dept.department_id}`,
            roleName: role.role || role.name || `Rol ${role.id}`,
            isActive: role.is_active,
            isPrimary: dept.is_primary_assignment,
            startDate: dept.start_date
          });
        });
      });
    });
  }

  return (
    <div className="mt-8 mb-6">
      <div className="rounded-2xl border border-gray-700 bg-gray-800 shadow-lg w-full min-w-0">
        <div className="px-4 sm:px-6 py-4 border-b border-gray-700">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-xl font-semibold text-white">
                Roles Asignados
              </h2>
              <p className="mt-1 text-sm text-gray-400">
                Empleado seleccionado: {fullName}
              </p>
            </div>
            {onSyncToAuthentik && (
              <button
                type="button"
                onClick={onSyncToAuthentik}
                className="px-4 py-2 rounded-lg border border-blue-600 bg-blue-600/20 text-blue-400 hover:bg-blue-600/30 hover:text-blue-300 transition-colors flex items-center gap-2"
                title="Sincronizar roles con Authentik"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
                Sincronizar con Authentik
              </button>
            )}
          </div>
        </div>
        <div className="p-4 sm:p-6 w-full min-w-0">
          
          {assignmentsLoading && (
            <div className="flex items-center gap-2 text-gray-400 text-sm">
              <Loader2 className="w-4 h-4 animate-spin" />
              Cargando asignaciones...
            </div>
          )}
          {assignmentsError && !assignmentsLoading && (
            <div className="rounded-lg border border-red-800 bg-red-900/20 p-4">
              <p className="text-red-300 text-sm">{assignmentsError}</p>
            </div>
          )}
          {!assignmentsLoading && !assignmentsError && employeeAssignments && (
            <>
              {roleCards.length > 0 ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                  {roleCards.map((card) => (
                    <div
                      key={card.key}
                      className="bg-gray-700/50 rounded-xl p-4 border border-gray-600 flex flex-col gap-2"
                    >
                      <p className="text-xs text-gray-400 truncate" title={card.factoryName}>
                        {card.factoryName}
                      </p>
                      <p className="text-xs text-gray-500 truncate" title={card.departmentName}>
                        {card.departmentName}
                      </p>
                      <div className="flex items-center gap-2 flex-wrap mt-1">
                        <span
                          className={
                            card.isActive
                              ? 'text-emerald-200 font-medium text-sm'
                              : 'text-gray-400 text-sm'
                          }
                        >
                          {card.roleName}
                          {!card.isActive && ' (Inactivo)'}
                        </span>
                        {onUnassignRole && (
                          <button
                            type="button"
                            onClick={() => onUnassignRole(card.factoryId, card.departmentId, card.roleName)}
                            className="ml-auto p-1.5 rounded-lg border border-red-600 bg-red-600/20 text-red-400 hover:bg-red-600/30 hover:text-red-300 transition-colors"
                            title="Eliminar rol"
                          >
                            <Trash2 className="w-4 h-4" />
                          </button>
                        )}
                      </div>
                      <div className="flex flex-wrap gap-1.5 mt-auto pt-2">
                        {card.isPrimary && (
                          <Badge className="bg-blue-900/50 text-blue-200 text-xs">
                            Principal
                          </Badge>
                        )}
                        {card.startDate && (
                          <span className="text-xs text-gray-500">
                            Desde: {formatDate(card.startDate)}
                          </span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-8">
                  <p className="text-gray-400">No hay roles asignados para este empleado</p>
                </div>
              )}
            </>
          )}
          {!assignmentsLoading && !assignmentsError && !employeeAssignments && (
            <div className="text-center py-8">
              <p className="text-gray-400">No hay información de asignaciones disponible</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};